import { css } from '@emotion/css';
import '../../styles/global';
import { breakpoints, responsiveMap } from './constants';
import { cache } from '../utils';
// const defaults = {};
// let grid: typeof defaults;
// setDefault(() => {
// grid = deepDefaults(theme, {grid: defaults}).grid;
// makeRowStyles?.clearCache();
// makeColStyles?.clearCache();
// });
export var makeRowStyles = cache(function makeRowStyles(k) {
  return /*#__PURE__*/css("position:relative;display:flex;flex-wrap:wrap;&.", k, "-justify-start{justify-content:flex-start;}&.", k, "-justify-end{justify-content:flex-end;}&.", k, "-justify-center{justify-content:center;}&.", k, "-justify-between{justify-content:space-between;}&.", k, "-justify-around{justify-content:space-around;}&.", k, "-justify-evenly{justify-content:space-evenly;}&.", k, "-align-top{align-items:flex-start;}&.", k, "-align-bottom{align-items:flex-end;}&.", k, "-align-middle{align-items:center;}&.", k, "-align-stretch{align-items:stretch;}&.", k, "-align-baseline{align-items:baseline;}");
});
export var makeColStyles = cache(function makeColStyles(k) {
  return /*#__PURE__*/css("position:relative;width:100%;.", k, "-col-wrapper{height:100%;}", makeBreakpointsCols(k), ";");
});
function makeBreakpointsCols(k) {
  var styles = [];
  styles.push(makeCols(k));
  for (var i = breakpoints.length - 1; i >= 0; i--) {
    var breakpoint = breakpoints[i];
    if (breakpoint === 'xs') continue;
    styles.push("@media " + responsiveMap[breakpoint] + " {");
    styles.push(makeCols(k + "-" + breakpoint));
    styles.push('}');
  }
  return styles.join('');
}
function makeCols(prefix) {
  var colsStyles = [];
  for (var i = 0; i < 24; i++) {
    var percentage = String(i / 24 * 100) + '%';
    colsStyles.push("\n            &." + prefix + "-" + i + " {\n                width: " + percentage + ";\n            }\n            &." + prefix + "-offset-" + i + " {\n                margin-left: " + percentage + ";\n            }\n            &." + prefix + "-order-" + i + " {\n                order: " + i + ";\n            }\n            &." + prefix + "-push-" + i + " {\n                left: " + percentage + ";\n            }\n            &." + prefix + "-pull-" + i + " {\n                right: " + percentage + ";\n            }\n        ");
  }
  return colsStyles.join('');
}